import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const ChartAreas = ({ data }) => {
  const sortedData = [...data].sort((a, b) => b.count - a.count);

  return (
    <div className="h-64 bg-white shadow-lg rounded-xl p-3">
      <span className="text-md font-semibold block mb-2">Relevance by area</span>
      <ResponsiveContainer width="100%" height="85%">
        <BarChart
          data={sortedData}
          layout="vertical"
          margin={{ top: 10, right: 30, bottom: 10, left: 60 }}
        >
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey="area"
            tick={{ fontSize: 12 }}
            width={70}
            interval={0}
            tickFormatter={(value) =>
              value.replace(/ /g, '\u00A0') // impede quebra de palavras compostas
            }
          />
          <Tooltip />
          <Bar dataKey="count" fill="#3b82f6">
            <LabelList dataKey="count" position="right" fill="#000" fontSize={12} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartAreas;
